import { render, staticRenderFns } from "./1_InhabilitantesAntiguos.vue?vue&type=template&id=106fc507&scoped=true"
import script from "./1_InhabilitantesAntiguos.vue?vue&type=script&lang=ts"
export * from "./1_InhabilitantesAntiguos.vue?vue&type=script&lang=ts"
import style0 from "./1_InhabilitantesAntiguos.vue?vue&type=style&index=0&id=106fc507&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106fc507",
  null
  
)

export default component.exports